import { Component } from '@angular/core';

@Component({
  selector: 'brt-search-location-filter-footer',
  templateUrl: './search-location-filter-footer.component.html',
  styleUrls: ['./search-location-filter-footer.component.scss']
})
export class SearchLocationFilterFooterComponent {

}
